import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/models/user';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-mobile-event20250415',
  templateUrl: './mobile-event20250415.component.html',
  styleUrls: ['./mobile-event20250415.component.css']
})
export class MobileEvent20250415Component implements OnInit {

  constructor(
      private commonService: CommonService,
      private router: Router
    ) {
      if(!this.commonService.getIsMobile()) {
        this.router.navigate(['/pc/event'])
      }
    }
  user: User
  ngOnInit(): void {
    this.user = this.commonService.getUserInfo()
  }
  moveJoin() {
    window.scrollTo(0, 0);
    this.router.navigate(['/join'])
  }
}
